<template>
  <WeatherContainer>
    <div class="login">
      <div class="form-title">
        会员登录
      </div>
      <div class="form">
        <!-- 用户名 -->
        <div class="form-item required">
          <div class="label">
            用户名
          </div>
          <div class="input">
            <Select
                v-model="formData.username"
                filterable
                remote
                placeholder="请输入单位营业执照全称"
                :remote-method="remoteMethod1"
                :loading="loading1">
                <Option v-for="(option, index) in options1" :value="option.value" :key="index">{{option.label}}</Option>
            </Select>
          </div>
        </div>
        <!-- 密码 -->
        <div class="form-item required">
          <div class="label">
            密码
          </div>
          <div class="input">
            <input type="password" v-model="formData.password" @keydown.enter="handleSubmit" placeholder="请输入您的登录密码">
          </div>
        </div>
        <!-- 验证码 -->
        <div class="form-item required getcode">
          <div class="label">
            验证码
          </div>
          <div class="input">
            <input type="text" v-model="formData.verify_code" placeholder="请输入验证码" @keydown.enter="handleSubmit">
            <img class="code middle-y" :src="getcodeUrl" alt="" @click="handleClickCode">
          </div>
        </div>
        <input type="button" value="登录" class="submit" @click="handleSubmit">
        <div class="intro">
          <div class="left">没有账号？点击这里 <b @click="$router.push('/Register')">注册</b>  </div>              
          <div class="right" @click="$router.push('/Forget')">忘记密码</div>
        </div>
      </div>
    </div>
  </WeatherContainer>
</template>
<script>
import WeatherContainer from '@/components/WeatherContainer'
import { getcode } from '@/utils/url'
import { Select, Option, Notice } from 'iview'
export default {
  components: {WeatherContainer, Select, Option},
  data() {
    return {
      model13: '',
      loading1: false,
      options1: [],
      getcodeUrl: getcode + '?t=' + Math.random(),
      formData: {
        username: '',
        password: '',
        verify_code: ''
      }
    }
  },
  methods: {
    remoteMethod1 (query) {
      console.log(query)
        if (query !== '') {
            this.loading1 = true;
            this.$store.dispatch('get_username', {username: query})
            .then(res => {
              this.loading1 = false;
              this.options1 = res.map(item => {
                return {
                  value: item.username,
                  label: item.username
                };
              });
            })
        } else {
            this.options1 = [];
        }
    },
    handleClickCode() {
      this.getcodeUrl = getcode + '?t=' + Date.now()
    },
    handleSubmit() {
      this.$store.dispatch('login', {...this.formData})
      .then(res => {
        Notice.success({
            title: '登录成功！',
            desc: ''
        });
        this.$router.push('/Home/VIP/BaseInfo')
      }, (e) => {
        if(e.code === 10008){
          this.handleClickCode()
        }
      })
    }
  }
}
</script>
<style lang="less" scoped>
.login {
  padding: 0 2.6rem;
  box-sizing: border-box;
  .form-title {
    text-align: center;
    line-height: 5.15rem;
    font-size: 1.2rem;
    color: #000;
  }
  .form {
    .form-item {
      margin-bottom: 1rem;
      height: 2.3rem;
        box-sizing: border-box;
      .label {
        height: 100%;
        line-height: 2.3rem;
        width: 4.75rem;
        float: left;
      }
      .input {
        width: 20rem;
        height: 2.3rem;
        float: left;
        /deep/ .ivu-select {
          width: 100%;
          height: 100%;
          .ivu-select-visible .ivu-select-selection {
            box-shadow: 0 0 0 rgba(0, 0, 0, 0)
          }
          .ivu-select-selection {
            height: 100%;
            width: 100%;
            padding-left: 0.2rem;
            outline: 0 none;
            border: 1px solid #eee;
            color: #333;
            font-weight: 700;
            box-shadow: 0 0 0 rgba(0, 0, 0, 0);
            >div {
                width: 100%;
                height: 100%;
              input {
                width: 100%;
                height: 100%;
                color: #333;
                font-weight: 700;
                font-size: 0.8rem;
                &::placeholder {
                  color: rgba(204, 204, 204, 1)
                }
              }
            }
          }
        }
        input {
          width: 100%;
          height: 100%;
          padding-left: 0.6rem;
          outline: 0 none;
          border: 1px solid #eee;
          color: #333;
          font-weight: 700;
          &::placeholder {
            color: rgba(204, 204, 204, 1)
          }
        }
      }
    }
    .form-item.required {
      .label {
        padding-left: 0.6rem;
        position: relative;
        &::before {
          content: "*";
          line-height: 1rem;
          color: rgba(246, 80, 80, 1);
          position: absolute;
          top: 50%;
          left: 0;
          transform: translateY(-50%);
        }
      }
    }
    .form-item.getcode {
      .input {
        position: relative;
        .code {
          position: absolute;
          width: 4.65rem;
          right: 0.4rem;
          cursor: pointer;
        }
      }
    }
    .submit {
      width: 24.8rem;
      height: 2.7rem;
      margin-top: 1.1rem;
      background: @btn-background;
      color: #fff;
      outline: 0 none;
      border: 0 none;
      cursor: pointer;
      font-size: 0.8rem;
      font-weight: 700;
    }
    .intro {
      margin-top: 0.8rem;
      b {
        color: @btn-background;
        cursor: pointer;
      }
      .left {
        float: left;
      }
      .right {
        color: @btn-background;
        cursor: pointer;
        float: right;
      }
    }
  }
}
</style>
